import { entity, field, IVo } from '../entity-maps';
import { Matrix, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { WizConstants } from '../../model/constants';

/**
 * VO matrice de donnée
 */
@entity('wizeoo.allkeyme.workingdata.message.Matrix', 'BU')
export class MatrixVO implements IVo {
  private _source: Matrix; // connecteur source

  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }

  constructor(model: Model, pSource?: Matrix) {
    this._model = model;
    this._source = null;
    if (pSource) {
      this._source = pSource;
    } else {
      this._source = new Matrix();
      this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau

    }
  }

  public set source(src: Matrix) {
    this._source = src;
  }

  public get source(): Matrix {
    return this._source;
  }

  public get id(): number {
    return this._source.id;
  }

  public set id(id: number) {
    this._source.id = id;
  }

  public get uid(): string {
    return this._source.uid;
  }
  public set uid(uid: string) {
    this._source.uid = uid;
  }

  /** Domaine */
  public set domain(domain: string) {
    this._source.domain = domain;
  }
  @field('string')
  public get domain(): string {
    return this._source.domain;
  }

  /** BU */
  public set businessUnitCode(businessUnitCode: string) {
    this._source.businessUnitCode = businessUnitCode;
  }
  @field('string')
  public get businessUnitCode(): string {
    return this._source.businessUnitCode;
  }

  /** Code */
  @field('string')
  public set code(code: string) {
    this._source.code = code;
  }
  public get code(): string {
    return this._source.code;
  }

  // TODO : détecter les changements sur les sous-collections
  @field('maintenanceFlag') // patch pour s'assurer de la demande de mise à jour sur contenu de steps
  public get maintenanceFlag(): string {
    return this._source.maintenanceFlag;
  }
  public set maintenanceFlag(value: string) {
    this._source.maintenanceFlag = value;
  }

  public get operation(): string {
    return this._source.operation;
  }
  public set operation(value: string) {
    this._source.operation = value;
  }

  @field('boolean')
  public get deprecated(): boolean {
    return this._source.deprecated;
  }
  public set deprecated(value: boolean) {
    this._source.deprecated = value;
  }

  public get deleted(): boolean {
    return this.source.deleted;
  }
  public set deleted(value: boolean) {
    this.source.deleted = value;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this._source.label = value;
  }
  public get label(): TranslatedEmb {
    return this._source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this._source.description = value;
  }
  public get description(): TranslatedEmb {
    return this._source.description;
  }

  public get rowCount(): number {
    return this._source.rowCount;
  }

  public set rowCount(value: number) {
    this._source.rowCount = value;
  }

  public get version(): number {
    return this._source.version;
  }

  public set version(value: number) {
    this._source.version = value;
  }


  // gestion des colonnes { [key: string]: string }
  // "0": "id", "1":"firstname"...
  public set columns(value: any) {
      this._source.columns = value;
  }
  public get columns(): any {
      return this._source.columns;
  }

  public set rows(value: any) {
      this._source.rows = value;
  }
  public get rows(): any {
      return this._source.rows;
  }

  /* ################################################
                    Accesseurs composites
  ################################################ */

  /** La matrice de données est-elle persistée? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this._source.id > 0;
  }

  /**
   * déjà chargée
   */
  public loaded: boolean = false;

  /* ################################################
              gestion des paramètres (json)
  ################################################ */

  public get uniqueKey(): string {
    return [this.domain, this.businessUnitCode, this.code].join(WizConstants.KEY_SEPARATOR);
  }

}
